import React, { useState, useEffect } from 'react'

import EmptyCard from '../EmptyCard'
import CardLayout from './CardLayout';
import {Grid} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { ChoiceSelectionSlice } from '../../../../store/store';


export default function CardListLayout({payload}) {
  const {cardList} = payload;
  const colsCount = useSelector((state)=>state.ChoiceSelectionSlice).params.colsCount;
  return (
    <>
    {cardList && cardList!=undefined && cardList.length!==0  ? 
        <Grid container  justifyContent="space-between" direction="row" padding={1}  spacing={2}>
        {
          cardList.map((card,i)=>{
            return( 
              <Grid item xs={colsCount.xs} sm={colsCount.sm} md={colsCount.md} lg={colsCount.lg} key={i}>
                  <CardLayout card={card} key={i} payload={payload}/>
              </Grid>
            )
          })
        }
        </Grid>:
        <EmptyCard/>  }

    </>
  )
}